import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-10/task-01";

const task: Slide = {
  titleHtml: `Try to put the displayed configurations in the correct order according to increasing loudness (from left to right)<br>by dragging the images to the appropriate positions below.`,
  description: "Drag and drop elements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
